import { SessionsApiFactory, V1AdminSession, V1SessionToken } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { AdminSession, SessionToken } from '@/models'
import { api, ApiResponse, createApiError } from './base'

function createSessionToken(
  rawSession?: V1SessionToken
): SessionToken | undefined {
  return new SessionToken({
    accessToken: rawSession?.accessToken,
    refreshToken: rawSession?.refreshToken,
    idToken: rawSession?.idToken,
  })
}

function createAdminSession(rawSession?: V1AdminSession): AdminSession | undefined {
  if (!rawSession) return undefined

  return new AdminSession({
    userId: rawSession.userId,
    companyId: rawSession.companyId,
    role: rawSession.role,
    mail: rawSession.mail,
    token: createSessionToken(rawSession.tokens)
  })
}

export const NewSessionsApiFunc = () => {
  const webAdapter = SessionsApiFactory(undefined, api.defaults.baseURL, api)

  return {
    authenticateAdmin: async (loginId?: string, password?: string): Promise<ApiResponse<AdminSession | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.authenticateAdminSession({
          data: {
            loginId: loginId,
            password: password
          }
        })
        data = createAdminSession(res.data.adminUser)
      } catch (e) {
        data = undefined
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    refreshToken: async (refreshToken?: string): Promise<ApiResponse<SessionToken | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.refreshToken({
          data: {
            refreshToken: refreshToken
          }
        })
        data = createSessionToken(res.data.tokens)
      } catch (e) {
        data = undefined
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    logout: async (accessToken?: string): Promise<ApiResponse<boolean>> => {
      let data, err

      try {
        await webAdapter.logout({
          data: {
            accessToken,
          }
        })
        data = true
      } catch (e) {
        data = false
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },
  }
}